import { createUrl, restGet } from '~/src/dash/api/rest';
import { EActive } from '~/src/dash/api/types/active';
import { EBool } from '~/src/dash/api/types/bool';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

// TODO: this is incomplete and needs specific typing.
interface IAudienceSegment {
  Active: EActive;
  AudienceSegmentType: number;
  CadentFilePath: string;
  CadentMeta: string;
  CreatedAt: string;
  DataProvider: string;
  DataSize: number;
  ID: number;
  IsFirstParty: EBool;
  LiverampCPM: number;
  LiverampOTTHubPrefix: string;
  Logic: number;
  LogicQuery: string;
  LogicQueryJson: string;
  Name: string;
  Partner: string;
  ThirdPartySegmentIDs: string;
  UniqueUserCount: number;
  UpdatedAt: string;
  URL: string;
  UUID: string;
}

interface IAudienceSegmentPromise {
  segments: IAudienceSegment[];
  success: boolean;
}

async function fetchAudienceSegments(publisherID: string): Promise<IAudienceSegmentPromise> {
  const reqUrl = createUrl('/segments', publisherID, 'v1');
  const response = await restGet<any>(reqUrl, {});
  return response.parsedBody;
}

export const generateAudienceSegmentOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  const shouldMaskLabel = checkUserInfoMasked(user.user);
  return fetchAudienceSegments(session.publisher.ID)
    .then(({ segments }) => {
      const options: ISelectOption[] = [];
      segments.forEach((segment) => {
        options.push({
          id: segment.ID,
          label: shouldMaskLabel ? `demo_audience_segment_${segment.ID}` : segment.Name,
          isActive: segment.Active === EActive.ACTIVE,
        });
      });
      return options;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};
